import { render, staticRenderFns } from "./ActBattleSupply.vue?vue&type=template&id=f6570634&scoped=true"
import script from "./ActBattleSupply.vue?vue&type=script&lang=js"
export * from "./ActBattleSupply.vue?vue&type=script&lang=js"
import style0 from "./ActBattleSupply.vue?vue&type=style&index=0&id=f6570634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6570634",
  null
  
)

export default component.exports